<template>
  <v-select
    :v-model="vmodel"
    :value="value"
    :items="items"
    :disabled="disabled"
    :height="height"
    :outlined="outlined"
    :append-icon="appendIcon"
    :dense="dense"
    :background-color="bgColor"
    :return-object="returnObject"
    :item-text="itemText"
    :item-value="itemValue"
    :color="color"
    :label="label"
    :multiple="multiple"
    :chips="chips"
    :readonly="readonly"
    :error-messages="errorMessages"
    @change="(value) => $emit('input', value)"
  />
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    vmodel: { type: [String, Object, Number, Array], default: null },
    value: { type: [String, Object, Number, Array], default: null },
    items: {
      type: Array,
      default: () => [],
    },
    disabled: { type: Boolean, default: false },
    height: { type: [Number, String], default: undefined },
    appendIcon: { type: String, default: undefined },
    bgColor: { type: String, default: undefined },
    returnObject: { type: Boolean, default: false },
    itemText: { type: String, default: null },
    itemValue: { type: String, default: null },
    color: { type: String, default: undefined },
    label: { type: String, default: '' },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    chips: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    errorMessages: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
